import { lazy } from 'react';
import { createRouteItem } from 'utils/navigation';
import type { RouterType } from 'commons/modules/routers/routes';
import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';

const PortfolioPositionsView = lazy(
  () => import('views/Clients/Positions/PortfolioPositions'),
);

const PortfolioLastMovementsView = lazy(
  () => import('views/Clients/Positions/PortfolioLastMovements'),
);

const PortfolioYieldsView = lazy(
  () => import('views/Clients/Positions/Yields'),
);

const routers: RouterType[] = [
  {
    exact: true,
    path: '/clientes/:clientid/portafolio-ultimos-movimientos',
    component: PortfolioLastMovementsView,
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.positionsMovements,
    breadcrumbs: {
      title: 'Movimientos',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Administración de clientes', '/clientes'),
      ],
    },
  },
  {
    exact: true,
    path: '/clientes/:clientid/posiciones-en-el-portafolio',
    component: PortfolioPositionsView,
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.positions,
    breadcrumbs: {
      title: 'Posiciones en el portafolio',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Administración de clientes', '/clientes'),
      ],
    },
  },

  {
    path: '/clientes/:clientid/rendimientos',
    component: PortfolioYieldsView,
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.positionsYields,
    exact: true,
    breadcrumbs: {
      title: 'Rendimientos',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Administración de clientes', '/clientes'),
      ],
    },
  },
];

export default routers;
